<template>
  <div class="orderRefunds appraisals">
    <div class="orderRefunds-box">
      <template v-for="item in detail.ORDER_GOODS_DETAILS">
        <div class="f-webkit-box" :key="item.id">
          <van-image :src="getImagePrefix+ item.COVER_URL" radius="6" class="order-img" />
          <div class="f-box-flex1">
            <div class="order-title">{{item.NAME}}</div>
            <div class="order-norms">规格：{{item.SKU_NAM}}</div>
          </div>
        </div>
      </template>
      <div class="f-p-t">
        <span class="appraisals-text">打分</span>
        <van-rate v-model="score" color="#FF5001" size="13" @change="onChange" />
        <span class="appraisals-text2">{{scoreDes}}</span>
      </div>
    </div>
    <div class="orderRefunds-box">
      <van-field v-model="content" placeholder="感谢您为宝贝提出的宝贵意见" type="textarea" />
      <van-uploader
        v-model="images"
        multiple
        preview-size="56"
        upload-text="添加图片"
        :max-count="6"
        class="orderRefunds-uploader"
      />
    </div>
    <div class="f-m-t-40">
      <van-button type="default" @click="submit">确 定</van-button>
    </div>
  </div>
</template>
<script>
import { Button, Uploader, Field, Rate } from "vant";
import http from "@js/http-hbt.js";
import { getOrderDetail, commentOrder, uploadFile } from "@js/shoppingUrl.js";
export default {
  components: {
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Field.name]: Field,
    [Rate.name]: Rate
  },
  data() {
    return {
      content: "", //评论内容
      score: 5,
      scoreDes: "", //描述
      images: [],
      detail: {}
    };
  },
  computed: {
    userId() {
      return this.$store.state.userInfo.userId;
    },
    getImagePrefix() {
      return this.$store.state.shoppingBlock.bgImgPrefix || "";
    }
  },
  methods: {
    onChange(value) {
      if (value === 1) {
        this.scoreDes = "非常差";
      } else if (value === 2) {
        this.scoreDes = "差";
      } else if (value === 3) {
        this.scoreDes = "一般";
      } else if (value === 4) {
        this.scoreDes = "好";
      } else if (value === 5) {
        this.scoreDes = "非常好";
      }
    },
    getDetail(orderId) {
      http.post(getOrderDetail, { orderId }).then(({ data }) => {
        this.detail = data;
      });
    },
    uploadFile(arr) {
      let files = arr.map(item => {
        return {
          FileUrl: item.content,
          IsRemoved: false,
          IsNew: true
        };
      });
      return http.post(
        uploadFile,
        { files: JSON.stringify(files) },
        {
          headers: { "content-type": "application/x-www-form-urlencoded" }
        }
      );
    },
    async submit() {
      let result = await this.uploadFile(this.images);
      let images = result.data.map(item => {
        return item.FileUrl;
      });
      let data = {
        orderId: this.orderId,
        userId: this.userId,
        content: this.content,
        score: this.score, //商品评分
        score2: 5, // 描述相符
        score4: 5, //卖家服务
        images: JSON.stringify(images)
      };
      http
        .post(commentOrder, data)
        .then(res => {
          this.$dialog
            .alert({
              message: "评论成功，点击确返回上一页"
            })
            .then(() => {
              this.$router.go(-1);
            });
        })
        .catch(({ msg }) => {
          this.$dialog.alert({
            message: msg
          });
        });
    }
  },
  created() {
    var { orderId } = this.$route.query;
    this.orderId = orderId;
    this.getDetail(orderId);
  }
};
</script>

<style lang="less" scoped>
.orderRefunds {
  background-color: #eff0fa !important;
  padding: 15px 7px;
  .orderRefunds-box {
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 18px 15px;
    margin-bottom: 10px;
    .order-img {
      width: 86px;
      height: 84px;
      margin-right: 10px;
    }
    .order-title {
      color: #1a1b1d;
      font-size: 12px;
      line-height: 18px;
    }
    .order-norms {
      color: #1a1b1d;
      font-size: 12px;
      line-height: 18px;
      padding-top: 15px;
    }
    .orderRefunds-text {
      color: #35373c;
      font-size: 12px;
      font-weight: 400;
      line-height: 18px;
    }
    .lh-24 {
      line-height: 24px;
    }
    .f-w-90 {
      width: 90px;
    }
    .orderRefunds-uploader {
      margin-top: 15px;
    }
    .appraisals-text {
      color: #343434;
      font-size: 12px;
      margin-right: 8px;
    }
    .appraisals-text2 {
      color: #343434;
      font-size: 12px;
      margin-left: 26px;
    }
  }
  .f-size-14 {
    font-size: 14px;
  }
  .f-size-16 {
    font-size: 16px;
  }
  .f-color-FF7613 {
    color: #ff7613;
  }
  .f-info-r {
    text-align: right;
  }
  .f-color-CECECE {
    color: #cecece;
  }
  .f-m-t-40 {
    margin-top: 40px;
  }
  .f-p-t {
    padding-top: 15px;
  }
  .f-box-flex1 {
    overflow: hidden;
    box-flex: 1;
    -webkit-box-flex: 1;
    -moz-box-flex: 1;
    flex: 1;
    -webkit-flex: 1;
  }
  .f-webkit-box {
    display: -webkit-flex;
    display: -webkit-box;
    display: -moz-flex;
    display: -moz-box;
    display: -ms-flex;
    display: -ms-box;
    // display: box;
    display: flex;
  }
}
</style>